import { render, staticRenderFns } from "./CreateRecord.vue?vue&type=template&id=52bd49d4&scoped=true"
import script from "./CreateRecord.vue?vue&type=script&lang=js"
export * from "./CreateRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd49d4",
  null
  
)

export default component.exports